export const getApplyPageURL = (id: number) =>
    `${process.env.REACT_APP_API_GET_APPLY_PAGE}`.replace("{id}", `${id}`);

class Client {
    async get(id: number) {
        const response = await fetch(getApplyPageURL(id));
        return await response.json();
    }
}

export default Client;
